import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return <div className="min-h-screen flex items-center justify-center font-body text-[#5C5C5C]">Carregando...</div>;
    }
    if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    if (user.role !== "admin") {
        return (
            <div className="min-h-screen flex items-center justify-center px-6">
                <div className="bg-white border border-black/5 rounded-3xl p-10 max-w-md text-center">
                    <div className="overline text-[#5C5C5C]">Acesso restrito</div>
                    <h1 className="font-display text-2xl mt-2">Área administrativa</h1>
                    <p className="font-body text-sm text-[#5C5C5C] mt-3">Você precisa ser administrador para acessar esta área.</p>
                </div>
            </div>
        );
    }
    return children;
}
